import { render } from "./EditBatch.vue?vue&type=template&id=1b354393"
import script from "./EditBatch.vue?vue&type=script&lang=js"
export * from "./EditBatch.vue?vue&type=script&lang=js"

import "./EditBatch.vue?vue&type=style&index=0&id=1b354393&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__